'use client';

import clsx from 'clsx';
import { useState } from 'react';
import { ChatIcon } from '@/assets/react-icons/ChatIcon';
import { OfferMessageIcon } from '@/assets/react-icons/OfferMessageIcon';
import { Button } from '../Button';
import { ContactSupportModal } from '../ContactSupportModal';
import { Text } from '../Text';
import styles from './OfferModalBtn.module.scss';
type Props = {
  buttonLarge?: boolean;
  className?: string;
  isFull?: boolean;
  label?: string;
};
export const OfferModalBtn = ({
  buttonLarge,
  className,
  isFull = false,
  label
}: Props) => {
  const [isOpen, setOpen] = useState(false);
  return <>
      {isFull ? <Button bordered className={clsx(className)} icon={<ChatIcon />} onClick={event => {
      event.preventDefault();
      setOpen(true);
    }} small>
          {buttonLarge ? <Text type='button_large'>{label ? label : 'Задати питання'}</Text> : <Text type='button_small'>{label ? label : 'Задати питання'}</Text>}
        </Button> : <button className={clsx(styles.wrapper, className)} onClick={event => {
      event.preventDefault();
      setOpen(true);
    }}>
          <OfferMessageIcon />
        </button>}

      <ContactSupportModal isOpen={isOpen} setOpen={setOpen} data-sentry-element="ContactSupportModal" data-sentry-source-file="OfferModalBtn.tsx" />
    </>;
};